import Avatar from '@mui/material/Avatar';
import AvatarIcon from '../../../../icons/AvatarIcon';
import { StateContextType } from '../../../../state';

export function getInitials(name: string) {
  const trimmed = name.trim();
  return trimmed.charAt(0).toUpperCase() + trimmed.charAt(1).toLowerCase();
}

export default function UserAvatar({ user }: { user: StateContextType['user'] }) {
  const { displayName, photoURL } = user!;

  return photoURL ? (
    <Avatar src={photoURL} />
  ) : (
    <AvatarIcon identity={displayName ? getInitials(displayName) : ''} color="default" size={40} />
  );
}
